import { UseOfName } from "../interfaces/enum";
import { ModelState } from "../interfaces/modelState";
import { post } from "../lib/fetchUtil";

interface BaseMutationRequest {
  policyNumber: string | null;
}

interface MutationResponse {
  modelState?: ModelState;
}

interface UpdateAddressRequest extends BaseMutationRequest {
  contactIds: string[];
  postcode: string;
  houseNumber: number;
  houseNumberAddition?: string;
  street: string;
  city: string;
  hasAdditionalAddressDetails: boolean;
  location: string;
  startDate: string;
}

export async function updateAddress(request: Partial<UpdateAddressRequest>): Promise<MutationResponse> {
  const response = await post(`mutation/address`, request);

  return response.json();
}

interface UpdateBankAccountRequest extends BaseMutationRequest {
  iban: string;
}

export async function updateBankAccount(request: UpdateBankAccountRequest): Promise<MutationResponse> {
  const response = await post(`mutation/bankAccount`, request);

  return response.json();
}

interface UpdatePhoneNumberRequest extends BaseMutationRequest {
  oldPhoneNumber?: string;
  newPhoneNumber: string;
}

export async function updatePhoneNumber(request: UpdatePhoneNumberRequest): Promise<MutationResponse> {
  const response = await post(`mutation/phoneNumber`, request);

  return response.json();
}

interface UpdateEmailAddressRequest extends BaseMutationRequest {
  oldEmailAddress?: string;
  newEmailAddress: string;
}

export async function updateEmailAddress(request: UpdateEmailAddressRequest): Promise<MutationResponse> {
  const response = await post(`mutation/emailAddress`, request);

  return response.json();
}

interface UpdatePersonalDataRequest extends BaseMutationRequest {
  salutation: string;
  initials: string;
  firstName: string;
  inserts?: string;
  lastName: string;
  partnerInserts?: string;
  partnerLastName?: string;
  useOfName?: UseOfName;
  usePartnerName: boolean;
  oldName: string;
}

export async function updatePersonalData(request: UpdatePersonalDataRequest): Promise<MutationResponse> {
  const response = await post(`mutation/personalData`, request);

  return response.json();
}

interface UpdateOtherDataRequest extends BaseMutationRequest {
  startDate?: string;
  description: string;
}

export async function updateOtherData(request: UpdateOtherDataRequest): Promise<MutationResponse> {
  const response = await post(`mutation/other`, request);

  return response.json();
}
